import { observer } from 'mobx-react';

interface Props {
  filterCount: number;
}

function Filters({ filterCount }: Props) {
  return (
    <div className="flex items-end w-full mb-8">
      <div className="h-8 w-[20%] bg-gray-300 rounded mr-[1.5%]"></div>
      <div className="w-[87%] flex">
        {[...Array(filterCount)].map((_, index) => (
          <div key={index} className="w-full mr-2">
            <div className="h-3 w-[50%] bg-gray-300 rounded mb-2"></div>
            <div className="h-8 w-full bg-gray-300 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default observer(Filters);
